module.exports = __webpack_public_path__ + "static/media/new15.07f987cd.jpg";